import Publicationcheck from '../../components/course/publicationcheck';
<template><Publicationcheck @course={{@model}} /></template>
